var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "inner-card" },
    [
      _c("ValidationObserver", {
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ handleSubmit }) {
              return [
                _c("loading", {
                  attrs: {
                    active: _vm.isLoading,
                    "enforce-focus": false,
                    loader: "dots",
                  },
                  on: {
                    "update:active": function ($event) {
                      _vm.isLoading = $event
                    },
                  },
                }),
                _vm.images.IsShowIdentityCardFile
                  ? [
                      _c("h4", { staticStyle: { "margin-bottom": "15px" } }, [
                        _c("span", { staticClass: "badge bg-warning" }, [
                          _vm._v(" 身分證/護照圖檔＋第二證件圖檔 "),
                        ]),
                      ]),
                      _vm.images.IdentityCardFiles.length < 5
                        ? _c(
                            "el-upload",
                            {
                              staticClass: "upload-demo",
                              staticStyle: { display: "inline-block" },
                              attrs: {
                                action: "",
                                accept: ".jpg,.jpeg,.png",
                                "auto-upload": false,
                                "show-file-list": false,
                                "on-change": _vm.uploadFile,
                                limit: 5,
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "small", type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.uploadFileType("identityCard")
                                    },
                                  },
                                },
                                [_vm._v(" 點擊上傳 ")]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.images.IdentityCardFiles.length < 5
                        ? _c(
                            "el-button",
                            {
                              staticStyle: { "margin-left": "10px" },
                              attrs: { size: "small", type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.openCamera("identityCard")
                                },
                              },
                            },
                            [_vm._v(" 開啟相機 ")]
                          )
                        : _vm._e(),
                      _vm._l(
                        _vm.images.IdentityCardFiles,
                        function (file, index) {
                          return _c("div", { key: file.FileGuid + "1" }, [
                            _c(
                              "p",
                              {
                                staticClass: "download-file",
                                on: {
                                  click: function ($event) {
                                    return _vm.$common.downloadFile({
                                      fileGuid: file.FileGuid,
                                      fileTitle: file.FileContentType,
                                    })
                                  },
                                },
                              },
                              [
                                _c("eva-icon", {
                                  attrs: {
                                    fill: "#fff",
                                    name: "attach-outline",
                                  },
                                }),
                                _c("span", { staticClass: "file-name" }, [
                                  _vm._v(" " + _vm._s(file.FileName) + " "),
                                ]),
                                _c(
                                  "span",
                                  {
                                    staticClass: "remove-file",
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.removeFile({
                                          fileGuid: file.FileGuid,
                                          fileGroupGuid: file.FileGroupGuid,
                                          fileTitle: "identityCard",
                                          fileIndex: index,
                                        })
                                      },
                                    },
                                  },
                                  [
                                    _c("eva-icon", {
                                      attrs: {
                                        fill: "#fff",
                                        name: "trash-2-outline",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ])
                        }
                      ),
                    ]
                  : _vm._e(),
                _vm.images.IsShowEducationFile
                  ? [
                      _c(
                        "h4",
                        {
                          staticStyle: {
                            "margin-top": "10px",
                            "margin-bottom": "15px",
                          },
                        },
                        [
                          _c("span", { staticClass: "badge bg-warning" }, [
                            _vm._v("畢業證書圖檔"),
                          ]),
                        ]
                      ),
                      _vm.images.EducationFiles.length < 5
                        ? _c(
                            "el-upload",
                            {
                              staticClass: "upload-demo",
                              staticStyle: { display: "inline-block" },
                              attrs: {
                                action: "",
                                accept: ".jpg,.jpeg,.png",
                                "auto-upload": false,
                                "show-file-list": false,
                                "on-change": _vm.uploadFile,
                                limit: 5,
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "small", type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.uploadFileType("education")
                                    },
                                  },
                                },
                                [_vm._v(" 點擊上傳 ")]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.images.EducationFiles.length < 5
                        ? _c(
                            "el-button",
                            {
                              staticStyle: { "margin-left": "10px" },
                              attrs: { size: "small", type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.openCamera("education")
                                },
                              },
                            },
                            [_vm._v(" 開啟相機 ")]
                          )
                        : _vm._e(),
                      _vm._l(_vm.images.EducationFiles, function (file) {
                        return _c("div", { key: file.FileGuid + "2" }, [
                          _c(
                            "p",
                            {
                              staticClass: "download-file",
                              on: {
                                click: function ($event) {
                                  return _vm.$common.downloadFile({
                                    fileGuid: file.FileGuid,
                                    fileTitle: file.FileContentType,
                                  })
                                },
                              },
                            },
                            [
                              _c("eva-icon", {
                                attrs: { fill: "#fff", name: "attach-outline" },
                              }),
                              _c("span", { staticClass: "file-name" }, [
                                _vm._v(" " + _vm._s(file.FileName) + " "),
                              ]),
                              _c(
                                "span",
                                {
                                  staticClass: "remove-file",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.removeFile({
                                        fileGuid: file.FileGuid,
                                        fileGroupGuid: file.FileGroupGuid,
                                        fileTitle: "education",
                                      })
                                    },
                                  },
                                },
                                [
                                  _c("eva-icon", {
                                    attrs: {
                                      fill: "#fff",
                                      name: "trash-2-outline",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ])
                      }),
                    ]
                  : _vm._e(),
                _vm.images.IsShowSeparationFile
                  ? [
                      _c(
                        "h4",
                        {
                          staticStyle: {
                            "margin-top": "10px",
                            "margin-bottom": "15px",
                          },
                        },
                        [
                          _c("span", { staticClass: "badge bg-warning" }, [
                            _vm._v(" 離職證明圖檔/勞保轉出單 "),
                          ]),
                        ]
                      ),
                      _vm.images.SeparationFiles.length < 5
                        ? _c(
                            "el-upload",
                            {
                              staticClass: "upload-demo",
                              staticStyle: { display: "inline-block" },
                              attrs: {
                                action: "",
                                accept: ".jpg,.jpeg,.png",
                                "auto-upload": false,
                                "show-file-list": false,
                                "on-change": _vm.uploadFile,
                                limit: 5,
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "small", type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.uploadFileType("separation")
                                    },
                                  },
                                },
                                [_vm._v(" 點擊上傳 ")]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.images.SeparationFiles.length < 5
                        ? _c(
                            "el-button",
                            {
                              staticStyle: { "margin-left": "10px" },
                              attrs: { size: "small", type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.openCamera("separation")
                                },
                              },
                            },
                            [_vm._v(" 開啟相機 ")]
                          )
                        : _vm._e(),
                      _vm._l(_vm.images.SeparationFiles, function (file) {
                        return _c("div", { key: file.FileGuid + "3" }, [
                          _c(
                            "p",
                            {
                              staticClass: "download-file",
                              on: {
                                click: function ($event) {
                                  return _vm.$common.downloadFile({
                                    fileGuid: file.FileGuid,
                                    fileTitle: file.FileContentType,
                                  })
                                },
                              },
                            },
                            [
                              _c("eva-icon", {
                                attrs: { fill: "#fff", name: "attach-outline" },
                              }),
                              _c("span", { staticClass: "file-name" }, [
                                _vm._v(" " + _vm._s(file.FileName) + " "),
                              ]),
                              _c(
                                "span",
                                {
                                  staticClass: "remove-file",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.removeFile({
                                        fileGuid: file.FileGuid,
                                        fileGroupGuid: file.FileGroupGuid,
                                        fileTitle: "separation",
                                      })
                                    },
                                  },
                                },
                                [
                                  _c("eva-icon", {
                                    attrs: {
                                      fill: "#fff",
                                      name: "trash-2-outline",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ])
                      }),
                    ]
                  : _vm._e(),
                _vm.images.IsShowMilitaryFile
                  ? [
                      _c(
                        "h4",
                        {
                          staticStyle: {
                            "margin-top": "10px",
                            "margin-bottom": "15px",
                          },
                        },
                        [
                          _c("span", { staticClass: "badge bg-warning" }, [
                            _vm._v("退伍令與免役證明圖檔"),
                          ]),
                        ]
                      ),
                      _vm.images.MilitaryFiles.length < 5
                        ? _c(
                            "el-upload",
                            {
                              staticClass: "upload-demo",
                              staticStyle: { display: "inline-block" },
                              attrs: {
                                action: "",
                                accept: ".jpg,.jpeg,.png",
                                "auto-upload": false,
                                "show-file-list": false,
                                "on-change": _vm.uploadFile,
                                limit: 5,
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "small", type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.uploadFileType("military")
                                    },
                                  },
                                },
                                [_vm._v(" 點擊上傳 ")]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.images.MilitaryFiles.length < 5
                        ? _c(
                            "el-button",
                            {
                              staticStyle: { "margin-left": "10px" },
                              attrs: { size: "small", type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.openCamera("military")
                                },
                              },
                            },
                            [_vm._v(" 開啟相機 ")]
                          )
                        : _vm._e(),
                      _vm._l(_vm.images.MilitaryFiles, function (file) {
                        return _c("div", { key: file.FileGuid + "4" }, [
                          _c(
                            "p",
                            {
                              staticClass: "download-file",
                              on: {
                                click: function ($event) {
                                  return _vm.$common.downloadFile({
                                    fileGuid: file.FileGuid,
                                    fileTitle: file.FileContentType,
                                  })
                                },
                              },
                            },
                            [
                              _c("eva-icon", {
                                attrs: { fill: "#fff", name: "attach-outline" },
                              }),
                              _c("span", { staticClass: "file-name" }, [
                                _vm._v(_vm._s(file.FileName)),
                              ]),
                              _c(
                                "span",
                                {
                                  staticClass: "remove-file",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.removeFile({
                                        fileGuid: file.FileGuid,
                                        fileGroupGuid: file.FileGroupGuid,
                                        fileTitle: "military",
                                      })
                                    },
                                  },
                                },
                                [
                                  _c("eva-icon", {
                                    attrs: {
                                      fill: "#fff",
                                      name: "trash-2-outline",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ])
                      }),
                    ]
                  : _vm._e(),
                _vm.images.IsShowDisabilityFile
                  ? [
                      _c(
                        "h4",
                        {
                          staticStyle: {
                            "margin-top": "10px",
                            "margin-bottom": "15px",
                          },
                        },
                        [
                          _c("span", { staticClass: "badge bg-warning" }, [
                            _vm._v("身心障礙手冊圖檔"),
                          ]),
                        ]
                      ),
                      _vm.images.DisabilityFiles.length < 5
                        ? _c(
                            "el-upload",
                            {
                              staticClass: "upload-demo",
                              staticStyle: { display: "inline-block" },
                              attrs: {
                                action: "",
                                accept: ".jpg,.jpeg,.png",
                                "auto-upload": false,
                                "show-file-list": false,
                                "on-change": _vm.uploadFile,
                                limit: 5,
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "small", type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.uploadFileType("disability")
                                    },
                                  },
                                },
                                [_vm._v(" 點擊上傳 ")]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.images.DisabilityFiles.length < 5
                        ? _c(
                            "el-button",
                            {
                              staticStyle: { "margin-left": "10px" },
                              attrs: { size: "small", type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.openCamera("disability")
                                },
                              },
                            },
                            [_vm._v(" 開啟相機 ")]
                          )
                        : _vm._e(),
                      _vm._l(_vm.images.DisabilityFiles, function (file) {
                        return _c("div", { key: file.FileGuid + "5" }, [
                          _c(
                            "p",
                            {
                              staticClass: "download-file",
                              on: {
                                click: function ($event) {
                                  return _vm.$common.downloadFile({
                                    fileGuid: file.FileGuid,
                                    fileTitle: file.FileContentType,
                                  })
                                },
                              },
                            },
                            [
                              _c("eva-icon", {
                                attrs: { fill: "#fff", name: "attach-outline" },
                              }),
                              _c("span", { staticClass: "file-name" }, [
                                _vm._v(_vm._s(file.FileName)),
                              ]),
                              _c(
                                "span",
                                {
                                  staticClass: "remove-file",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.removeFile({
                                        fileGuid: file.FileGuid,
                                        fileGroupGuid: file.FileGroupGuid,
                                        fileTitle: "disability",
                                      })
                                    },
                                  },
                                },
                                [
                                  _c("eva-icon", {
                                    attrs: {
                                      fill: "#fff",
                                      name: "trash-2-outline",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ])
                      }),
                    ]
                  : _vm._e(),
                _vm.images.IsShowHouseholdFile
                  ? [
                      _c(
                        "h4",
                        {
                          staticStyle: {
                            "margin-top": "10px",
                            "margin-bottom": "15px",
                          },
                        },
                        [
                          _c("span", { staticClass: "badge bg-warning" }, [
                            _vm._v("戶籍謄本圖檔"),
                          ]),
                        ]
                      ),
                      _vm.images.HouseholdFiles.length < 5
                        ? _c(
                            "el-upload",
                            {
                              staticClass: "upload-demo",
                              staticStyle: { display: "inline-block" },
                              attrs: {
                                action: "",
                                accept: ".jpg,.jpeg,.png",
                                "auto-upload": false,
                                "show-file-list": false,
                                "on-change": _vm.uploadFile,
                                limit: 5,
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "small", type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.uploadFileType("household")
                                    },
                                  },
                                },
                                [_vm._v(" 點擊上傳 ")]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.images.HouseholdFiles.length < 5
                        ? _c(
                            "el-button",
                            {
                              staticStyle: { "margin-left": "10px" },
                              attrs: { size: "small", type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.openCamera("household")
                                },
                              },
                            },
                            [_vm._v(" 開啟相機 ")]
                          )
                        : _vm._e(),
                      _vm._l(_vm.images.HouseholdFiles, function (file) {
                        return _c("div", { key: file.FileGuid + "6" }, [
                          _c(
                            "p",
                            {
                              staticClass: "download-file",
                              on: {
                                click: function ($event) {
                                  return _vm.$common.downloadFile({
                                    fileGuid: file.FileGuid,
                                    fileTitle: file.FileContentType,
                                  })
                                },
                              },
                            },
                            [
                              _c("eva-icon", {
                                attrs: { fill: "#fff", name: "attach-outline" },
                              }),
                              _c("span", { staticClass: "file-name" }, [
                                _vm._v(_vm._s(file.FileName)),
                              ]),
                              _c(
                                "span",
                                {
                                  staticClass: "remove-file",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.removeFile({
                                        fileGuid: file.FileGuid,
                                        fileGroupGuid: file.FileGroupGuid,
                                        fileTitle: "household",
                                      })
                                    },
                                  },
                                },
                                [
                                  _c("eva-icon", {
                                    attrs: {
                                      fill: "#fff",
                                      name: "trash-2-outline",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ])
                      }),
                    ]
                  : _vm._e(),
                _vm.images.IsShowBankBookFile
                  ? [
                      _c(
                        "h4",
                        {
                          staticStyle: {
                            "margin-top": "10px",
                            "margin-bottom": "15px",
                          },
                        },
                        [
                          _c("span", { staticClass: "badge bg-warning" }, [
                            _vm._v("存摺"),
                          ]),
                        ]
                      ),
                      _vm.images.BankBookFiles.length < 5
                        ? _c(
                            "el-upload",
                            {
                              staticClass: "upload-demo",
                              staticStyle: { display: "inline-block" },
                              attrs: {
                                action: "",
                                accept: ".jpg,.jpeg,.png",
                                "auto-upload": false,
                                "show-file-list": false,
                                "on-change": _vm.uploadFile,
                                limit: 5,
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "small", type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.uploadFileType("bankbook")
                                    },
                                  },
                                },
                                [_vm._v(" 點擊上傳 ")]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.images.BankBookFiles.length < 5
                        ? _c(
                            "el-button",
                            {
                              staticStyle: { "margin-left": "10px" },
                              attrs: { size: "small", type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.openCamera("bankbook")
                                },
                              },
                            },
                            [_vm._v(" 開啟相機 ")]
                          )
                        : _vm._e(),
                      _c("div", { staticClass: "row mt-3" }, [
                        _c("div", { staticClass: "col-4" }, [
                          _c(
                            "div",
                            { staticClass: "form-group form-inline" },
                            [
                              _c(
                                "label",
                                {
                                  staticStyle: { color: "#fff" },
                                  attrs: { for: "" },
                                },
                                [_vm._v("銀行代碼")]
                              ),
                              _c(
                                "el-select",
                                {
                                  staticClass: "w-100",
                                  attrs: {
                                    clearable: "",
                                    placeholder: "請選擇",
                                  },
                                  model: {
                                    value: _vm.images.BankCode,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.images, "BankCode", $$v)
                                    },
                                    expression: "images.BankCode",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "郵局", value: "700" },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "中國信託", value: "822" },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                        _c("div", { staticClass: "col-8" }, [
                          _c(
                            "div",
                            { staticClass: "form-group form-inline" },
                            [
                              _c(
                                "label",
                                {
                                  staticStyle: { color: "#fff" },
                                  attrs: { for: "" },
                                },
                                [_vm._v("銀行帳號")]
                              ),
                              _c("el-input", {
                                attrs: {
                                  placeholder: "請輸入銀行帳號",
                                  maxlength: "20",
                                },
                                model: {
                                  value: _vm.images.BankAccount,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.images,
                                      "BankAccount",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "images.BankAccount",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]),
                      _vm._l(_vm.images.BankBookFiles, function (file) {
                        return _c("div", { key: file.FileGuid + "7" }, [
                          _c(
                            "p",
                            {
                              staticClass: "download-file",
                              on: {
                                click: function ($event) {
                                  return _vm.$common.downloadFile({
                                    fileGuid: file.FileGuid,
                                    fileTitle: file.FileContentType,
                                  })
                                },
                              },
                            },
                            [
                              _c("eva-icon", {
                                attrs: { fill: "#fff", name: "attach-outline" },
                              }),
                              _c("span", { staticClass: "file-name" }, [
                                _vm._v(_vm._s(file.FileName)),
                              ]),
                              _c(
                                "span",
                                {
                                  staticClass: "remove-file",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.removeFile({
                                        fileGuid: file.FileGuid,
                                        fileGroupGuid: file.FileGroupGuid,
                                        fileTitle: "bankbook",
                                      })
                                    },
                                  },
                                },
                                [
                                  _c("eva-icon", {
                                    attrs: {
                                      fill: "#fff",
                                      name: "trash-2-outline",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ])
                      }),
                    ]
                  : _vm._e(),
                _vm.images.IsShowUnder18File
                  ? [
                      _c(
                        "h4",
                        {
                          staticStyle: {
                            "margin-top": "10px",
                            "margin-bottom": "15px",
                          },
                        },
                        [
                          _c("span", { staticClass: "badge bg-warning" }, [
                            _vm._v("未滿18歲同意書"),
                          ]),
                        ]
                      ),
                      _c("ValidationProvider", {
                        ref: "Under18Files",
                        attrs: { rules: "required" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ errors }) {
                                return [
                                  _vm.images.Under18Files.length < 5
                                    ? _c(
                                        "el-upload",
                                        {
                                          ref: "",
                                          staticClass: "upload-demo",
                                          staticStyle: {
                                            display: "inline-block",
                                          },
                                          attrs: {
                                            action: "",
                                            accept: ".jpg,.jpeg,.png",
                                            "auto-upload": false,
                                            "show-file-list": false,
                                            "on-change": _vm.uploadFile,
                                            limit: 5,
                                          },
                                          model: {
                                            value: _vm.images.Under18Files,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.images,
                                                "Under18Files",
                                                $$v
                                              )
                                            },
                                            expression: "images.Under18Files",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                size: "small",
                                                type: "primary",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.uploadFileType(
                                                    "under18"
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v(" 點擊上傳 ")]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.images.Under18Files.length < 5
                                    ? _c(
                                        "el-button",
                                        {
                                          staticStyle: {
                                            "margin-left": "10px",
                                          },
                                          attrs: {
                                            size: "small",
                                            type: "primary",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.openCamera("under18")
                                            },
                                          },
                                        },
                                        [_vm._v(" 開啟相機 ")]
                                      )
                                    : _vm._e(),
                                  errors[0]
                                    ? _c(
                                        "span",
                                        { staticClass: "text-danger" },
                                        [_vm._v(" " + _vm._s(errors[0]) + " ")]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                      _vm._l(_vm.images.Under18Files, function (file) {
                        return _c("div", { key: file.FileGuid + "8" }, [
                          _c(
                            "p",
                            {
                              staticClass: "download-file",
                              on: {
                                click: function ($event) {
                                  return _vm.$common.downloadFile({
                                    fileGuid: file.FileGuid,
                                    fileTitle: file.FileContentType,
                                  })
                                },
                              },
                            },
                            [
                              _c("eva-icon", {
                                attrs: { fill: "#fff", name: "attach-outline" },
                              }),
                              _c("span", { staticClass: "file-name" }, [
                                _vm._v(_vm._s(file.FileName)),
                              ]),
                              _c(
                                "span",
                                {
                                  staticClass: "remove-file",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.removeFile({
                                        fileGuid: file.FileGuid,
                                        fileGroupGuid: file.FileGroupGuid,
                                        fileTitle: "under18",
                                      })
                                    },
                                  },
                                },
                                [
                                  _c("eva-icon", {
                                    attrs: {
                                      fill: "#fff",
                                      name: "trash-2-outline",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ])
                      }),
                    ]
                  : _vm._e(),
                _vm.images.IsShowIndustryAcademyCooperationFile
                  ? [
                      _c(
                        "h4",
                        {
                          staticStyle: {
                            "margin-top": "10px",
                            "margin-bottom": "15px",
                          },
                        },
                        [
                          _c("span", { staticClass: "badge bg-warning" }, [
                            _vm._v("產學合作四方合約書"),
                          ]),
                        ]
                      ),
                      _vm.images.IndustryAcademyCooperationFiles.length < 5
                        ? _c(
                            "el-upload",
                            {
                              staticClass: "upload-demo",
                              staticStyle: { display: "inline-block" },
                              attrs: {
                                action: "",
                                accept: ".jpg,.jpeg,.png",
                                "auto-upload": false,
                                "show-file-list": false,
                                "on-change": _vm.uploadFile,
                                limit: 5,
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "small", type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.uploadFileType(
                                        "industryAcademyCooperation"
                                      )
                                    },
                                  },
                                },
                                [_vm._v(" 點擊上傳 ")]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.images.IndustryAcademyCooperationFiles.length < 5
                        ? _c(
                            "el-button",
                            {
                              staticStyle: { "margin-left": "10px" },
                              attrs: { size: "small", type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.openCamera(
                                    "industryAcademyCooperation"
                                  )
                                },
                              },
                            },
                            [_vm._v(" 開啟相機 ")]
                          )
                        : _vm._e(),
                      _vm._l(
                        _vm.images.IndustryAcademyCooperationFiles,
                        function (file) {
                          return _c("div", { key: file.FileGuid + "9" }, [
                            _c(
                              "p",
                              {
                                staticClass: "download-file",
                                on: {
                                  click: function ($event) {
                                    return _vm.$common.downloadFile({
                                      fileGuid: file.FileGuid,
                                      fileTitle: file.FileContentType,
                                    })
                                  },
                                },
                              },
                              [
                                _c("eva-icon", {
                                  attrs: {
                                    fill: "#fff",
                                    name: "attach-outline",
                                  },
                                }),
                                _c("span", { staticClass: "file-name" }, [
                                  _vm._v(_vm._s(file.FileName)),
                                ]),
                                _c(
                                  "span",
                                  {
                                    staticClass: "remove-file",
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.removeFile({
                                          fileGuid: file.FileGuid,
                                          fileGroupGuid: file.FileGroupGuid,
                                          fileTitle:
                                            "industryAcademyCooperation",
                                        })
                                      },
                                    },
                                  },
                                  [
                                    _c("eva-icon", {
                                      attrs: {
                                        fill: "#fff",
                                        name: "trash-2-outline",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ])
                        }
                      ),
                    ]
                  : _vm._e(),
                _vm.images.IsShowIPChangeTagFile
                  ? [
                      _c(
                        "h4",
                        {
                          staticStyle: {
                            "margin-top": "10px",
                            "margin-bottom": "15px",
                          },
                        },
                        [
                          _c("span", { staticClass: "badge bg-warning" }, [
                            _vm._v("既有智財評估"),
                          ]),
                        ]
                      ),
                      _c(
                        "el-upload",
                        {
                          staticClass: "upload-demo",
                          staticStyle: { display: "inline-block" },
                          attrs: {
                            action: "",
                            accept: ".jpg,.jpeg,.png",
                            "auto-upload": false,
                            "show-file-list": false,
                            "on-change": _vm.uploadFile,
                          },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small", type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.uploadFileType("ip")
                                },
                              },
                            },
                            [_vm._v(" 點擊上傳 ")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-button",
                        {
                          staticStyle: { "margin-left": "10px" },
                          attrs: { size: "small", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.openCamera("ip")
                            },
                          },
                        },
                        [_vm._v(" 開啟相機 ")]
                      ),
                      _vm._l(_vm.images.IPChangeTagFiles, function (file) {
                        return _c("div", { key: file.FileGuid + "10" }, [
                          _c(
                            "p",
                            {
                              staticClass: "download-file",
                              on: {
                                click: function ($event) {
                                  return _vm.$common.downloadFile({
                                    fileGuid: file.FileGuid,
                                    fileTitle: file.FileContentType,
                                  })
                                },
                              },
                            },
                            [
                              _c("eva-icon", {
                                attrs: { fill: "#fff", name: "attach-outline" },
                              }),
                              _c("span", { staticClass: "file-name" }, [
                                _vm._v(_vm._s(file.FileName)),
                              ]),
                              _c(
                                "span",
                                {
                                  staticClass: "remove-file",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.removeFile({
                                        fileGuid: file.FileGuid,
                                        fileGroupGuid: file.FileGroupGuid,
                                        fileTitle: "ip",
                                      })
                                    },
                                  },
                                },
                                [
                                  _c("eva-icon", {
                                    attrs: {
                                      fill: "#fff",
                                      name: "trash-2-outline",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ])
                      }),
                    ]
                  : _vm._e(),
                _vm.images.IsShowOtherFile
                  ? [
                      _c(
                        "h4",
                        {
                          staticStyle: {
                            "margin-top": "10px",
                            "margin-bottom": "15px",
                          },
                        },
                        [
                          _c("span", { staticClass: "badge bg-warning" }, [
                            _vm._v("其他"),
                          ]),
                        ]
                      ),
                      _c(
                        "el-upload",
                        {
                          staticClass: "upload-demo",
                          staticStyle: { display: "inline-block" },
                          attrs: {
                            action: "",
                            accept: ".jpg,.jpeg,.png",
                            "auto-upload": false,
                            "show-file-list": false,
                            "on-change": _vm.uploadFile,
                          },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small", type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.uploadFileType("other")
                                },
                              },
                            },
                            [_vm._v(" 點擊上傳 ")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-button",
                        {
                          staticStyle: { "margin-left": "10px" },
                          attrs: { size: "small", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.openCamera("other")
                            },
                          },
                        },
                        [_vm._v(" 開啟相機 ")]
                      ),
                      _vm._l(_vm.images.OtherFiles, function (file) {
                        return _c("div", { key: file.FileGuid + "11" }, [
                          _c(
                            "p",
                            {
                              staticClass: "download-file",
                              on: {
                                click: function ($event) {
                                  return _vm.$common.downloadFile({
                                    fileGuid: file.FileGuid,
                                    fileTitle: file.FileContentType,
                                  })
                                },
                              },
                            },
                            [
                              _c("eva-icon", {
                                attrs: { fill: "#fff", name: "attach-outline" },
                              }),
                              _c("span", { staticClass: "file-name" }, [
                                _vm._v(_vm._s(file.FileName)),
                              ]),
                              _c(
                                "span",
                                {
                                  staticClass: "remove-file",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.removeFile({
                                        fileGuid: file.FileGuid,
                                        fileGroupGuid: file.FileGroupGuid,
                                        fileTitle: "other",
                                      })
                                    },
                                  },
                                },
                                [
                                  _c("eva-icon", {
                                    attrs: {
                                      fill: "#fff",
                                      name: "trash-2-outline",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ])
                      }),
                    ]
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "edit-btn-wrap" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini" },
                        on: {
                          click: function ($event) {
                            return handleSubmit(_vm.saveImages)
                          },
                        },
                      },
                      [_vm._v(" 儲存 ")]
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "拍照",
            visible: _vm.cameraVisible,
            width: "400px",
            "destroy-on-close": true,
            max: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.cameraVisible = $event
            },
          },
        },
        [
          _c("vue-web-cam", {
            ref: "webcam",
            attrs: { height: "auto", width: "100%" },
            on: { cameras: _vm.onCameras },
          }),
          _c(
            "el-select",
            {
              staticStyle: { width: "100%" },
              attrs: { placeholder: "請選擇鏡頭" },
              on: { change: _vm.changeCamera },
              model: {
                value: _vm.currentCameras,
                callback: function ($$v) {
                  _vm.currentCameras = $$v
                },
                expression: "currentCameras",
              },
            },
            _vm._l(_vm.cameras, function (item) {
              return _c("el-option", {
                key: item.deviceId,
                attrs: { label: item.label, value: item.deviceId },
              })
            }),
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.cameraVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onCapture } },
                [_vm._v("確定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }